var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.000000,530.000000) scale(0.100000,-0.100000)",
    fill: "#fd3800",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 4367 l0 -83 38 -18 c66 -33 173 -65 294 -91 65 -14 120 -25 123 -25 3 0 5 -571 5 -1269 l0 -1269 -42 -7 c-63 -11 -157 -41 -300 -97 l-128 -49 0 -85 0 -84 670 0 670 0 0 85 0 84 -47 21 c-74 33 -276 98 -351 113 l-67 14 -3 1217 -2 1217 27 -3 c25 -3 32 -18 126 -268 88 -236 156 -385 626 -1370 l528 -1105 124 -3 125 -3 18 38 c10 21 250 523 532 1116 429 901 528 1118 605 1322 84 222 95 245 116 245 28 0 27 21 8 -325 -11 -191 -15 -504 -15 -1177 l0 -918 -27 -6 c-130 -29 -306 -83 -395 -119 -15 -6 -18 -21 -18 -91 l0 -84 825 0 825 0 0 84 0 84 -42 17 c-87 35 -156 57 -263 85 l-110 28 -3 1280 -2 1279 112 27 c62 15 156 44 208 64 l95 38 3 87 3 87 -682 -2 -681 -3 -432 -920 c-338 -719 -450 -966 -511 -1133 -43 -116 -81 -212 -84 -212 -4 0 -44 100 -89 223 -59 160 -199 476 -500 1132 l-418 910 -747 3 -747 2 0 -83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.a8cde30039198a1c028df5341a8d3a72.svg";
export { ForwardRef as ReactComponent };